<template>
  <mdb-container>
    <mdb-row>
      <mdb-col>
        <Errors v-show="!!error" :error="error" />
        <div v-show="showSpinner">
          <Spinner />
        </div>
      </mdb-col>
    </mdb-row>

    <mdb-row>
      <mdb-tbl striped borderless class="wide">
        <mdb-tbl-head>
          <tr>
            <th>Email</th>
            <th>Role</th>
            <th>Location</th>
            <th>Assigned State</th>
            <th>Created On</th>
            <th>Action</th>
          </tr>
        </mdb-tbl-head>

        <transition-group tag="tbody" name="fade">
          <tr v-for="user in userList.rows" :key="user.id">
            <td>{{ user.email }}</td>
            <td>{{ user.role }}</td>
            <td>{{ user.station_location }}</td>
            <td>{{ user.station_state }}</td>
            <td>{{ user.created_at | formatDate }}</td>
            <td>
              <mdb-btn
                color="dark"
                v-on:click="removeUser(user)"
                outline="primary"
                icon="minus"
                size="sm"
                >Remove</mdb-btn
              >
            </td>
          </tr>
        </transition-group>
      </mdb-tbl>
    </mdb-row>

    <mdb-row>
      <mdb-modal :show="showDeleteModal" @close="showDeleteModal = false">
        <mdb-modal-header>
          <mdb-modal-title
            >Remove User ({{ selectedUser.role }})
          </mdb-modal-title>
        </mdb-modal-header>
        <mdb-modal-body
          >Do you want to permanently delete this user?

          <strong>{{ selectedUser.email }}</strong>
          <br />
          <strong
            >Station: {{ selectedUser.station_location }} -
            {{ selectedUser.station_state }}
          </strong>
        </mdb-modal-body>
        <mdb-modal-footer>
          <mdb-btn outline="primary" @click.native="showDeleteModal = false"
            >No</mdb-btn
          >
          <mdb-btn color="primary" v-on:click="deleteUser()"
            >Yes, Delete</mdb-btn
          >
        </mdb-modal-footer>
      </mdb-modal>
    </mdb-row>
  </mdb-container>
</template>

<script>
import api from "@/api";
import dateFns from "date-fns";
import Errors from "@/components/Errors";
import Spinner from "@/components/Spinner";

import {
  mdbDatatable,
  mdbContainer,
  mdbRow,
  mdbCol,
  mdbBtn,
  mdbTbl,
  mdbTblHead,
  mdbTblBody,
  mdbModal,
  mdbModalTitle,
  mdbModalHeader,
  mdbModalFooter,
  mdbModalBody,
} from "mdbvue";
// import Spinner from "@/components/Spinner";

export default {
  name: "usersList",
  props: {
    users: {
      type: Array,
      required: true,
    },
  },

  filters: {
    formatDate(date) {
      return dateFns.format(date, "MMMM Do [at] h:mm:ss a");
    },
  },

  components: {
    mdbContainer,
    mdbDatatable,
    mdbRow,
    mdbCol,
    mdbBtn,
    mdbTbl,
    mdbTblHead,
    mdbTblBody,
    mdbModal,
    mdbModalTitle,
    mdbModalHeader,
    mdbModalFooter,
    mdbModalBody,
    Spinner,
    Errors,
  },
  data() {
    return {
      isLoading: true,
      showDeleteModal: false,
      selectedUser: {},
      error: "",
      userList: {
        rows: [],
      },
    };
  },
  created() {
    this.userList.rows = this.users;
    this.isLoading = false;
  },
  methods: {
    removeUser(user) {
      this.selectedUser = user;
      this.showDeleteModal = true;
    },

    deleteUser() {
      this.isLoading = true;
      this.showDeleteModal = false;
      api
        .deleteUser(this.selectedUser.id)
        .then((response) => {
          this.userList.rows = [...response.data];
          this.isLoading = false;
        })
        .catch((error) => {
          this.error = error.response.data.errors.full_messages[0];
        });
    },
  },
  computed: {
    showSpinner() {
      return this.isLoading;
    },
  },
};
</script>

<style scoped lang="scss">
.wide {
  width: 80vw;
}
</style>
